import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const InputGroup = ({
    children,
    containerClass,
    customClasses,
    errorClassName,
    id,
    label,
    required,
    showRequiredSymbol,
}) => {
    return (
        <Fragment>
            {label ? (
                <label className="gx-label" htmlFor={id}>
                    {label}
                    {required || showRequiredSymbol ? (
                        <span className="gx-label__required">*</span>
                    ) : null}
                </label>
            ) : null}
            <div
                id={id}
                className={classNames(
                    containerClass,
                    customClasses,
                    errorClassName,
                    { 'is-required': required }
                )}
            >
                {children}
            </div>
        </Fragment>
    );
};

InputGroup.propTypes = {
    label: PropTypes.string,
    id: PropTypes.string.isRequired,
    customClasses: PropTypes.string,
    containerClass: PropTypes.string,
    errorClassName: PropTypes.string,
    required: PropTypes.bool,
    showRequiredSymbol: PropTypes.bool,
};

InputGroup.defaultProps = {
    containerClass: 'gx-form-group',
};
